import Navigator from './services/Navigator';
import Vue from 'vue';

new Vue({
    components: {
        Navigator
    },

    computed: {
        banner() {
            return this.$refs.banner;
        }
    },

    data() {
        return {
            defaults: null,
        };
    },

    methods: {
        change(service) {
            const path = `url("${service.banner}")`;

            if (!this.invalid(path)) {
                this.banner.style.backgroundImage = path;
            } else if (this.defaults) {
                this.banner.style.backgroundImage = this.defaults;
            }

            this.display();
        },

        display(defaults) {
            const path = this.banner.style.backgroundImage;

            /**
             * If background image is empty then `path` might be `url("/storage/")`;
             */
            if (this.invalid(path)) {
                this.banner.style.display = 'none';
            } else {
                this.banner.style.display = 'block';

                if (defaults) {
                    this.defaults = path;
                }
            }
        },

        invalid(path) {
            return !path || path.slice(-3, -2) === '/';
        }
    },

    mounted() {
        this.display(true);
    }
}).$mount('#main');
